export default {"src":"/_next/static/image/public/images/flags/flag_258.beae143894939e589a3c7b743319b7c1.svg","height":16,"width":24};